'use strict';

(function () {
  'use strict';

  angular.module('msProfile').component('msProfile', {
    bindings: {
      user: '<'
    },
    templateUrl: 'profile/pages/profile.html',
    controller: ['$rootScope', 'languageSvc', 'providerSvc', 'nameRegex', 'userSvc', '$state', '$q', '$log', 'msAuth', 'trainSvc', '$timeout', 'countryGdprConfig', profileCompCtrl]

  });

  profileCompCtrl.$inject = ['trainSvc'];

  function profileCompCtrl($rootScope, languageSvc, providerSvc, nameRegex, userSvc, $state, $q, $log, msAuth, trainSvc, $timeout, countryGdprConfig) {
    // NOSONAR
    var vm = this;
    var LAST_NAME = 'LAST_NAME';
    var OPTED_INTO_COACHING_EMAIL_PREFERENCE_KEY = 'optedIntoCoachingEmails';
    var OPTED_INTO_ASSESSMENT_EMAIL_PREFERENCE_KEY = 'optedIntoAssessmentEmails';
    var OPTED_INTO_CONSUMER_EMAIL_PREFERENCE_KEY = 'optedIntoConsumerEmails';
    var OPTED_INTO_SLEEP_DIARY_EMAIL_PREFERENCE_KEY = 'sleep_diary_reminder:email';
    var SLEEP_DIARY_ENABLED_TRUE = 'sleep_diary_enabled:true';
    var SLEEP_DIARY_DISABLED_TRUE = 'sleep_diary_enabled:false';

    vm.apiUser = {};
    vm.$onInit = init;
    vm.save = save;
    vm.clearTrains = trainSvc.clearTrains;
    vm.updatePreferences = updatePreferences;
    vm.getTranslationKey = getTranslationKey;
    vm.nameRegex = new RegExp(nameRegex);
    vm.hasPermission = msAuth.hasPermission;
    vm.sleepDiaryEnabled = false;
    // Setup coaching election radio
    vm.userCanOptInOutOfCoaching = false;
    vm.supportedLanguages = [];
    vm.countryGdprConfig = countryGdprConfig.getFromStorage();

    vm.isMacOSSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !/iphone|ipad|ipod|ios/i.test(navigator.userAgent);

    languageSvc.getSupportedLanguages().then(function (supportedLanguages) {
      vm.supportedLanguages = supportedLanguages;
    });

    ///////////////////////////////////////
    function init() {
      vm.emailPrefs = vm.user.userPreferences.emailPrefs ? JSON.parse(vm.user.userPreferences.emailPrefs) : {};
      vm.user.optedIntoCoachingEmails = true;
      vm.user.optedIntoAssessmentEmails = true;
      vm.user.optedIntoConsumerEmails = true;
      vm.user.optedIntoSleepDiaryEmails = false;
      vm.user.coachingEnabled = false;

      vm.success = false;
      vm.emailBlacklist = [];
      vm.nameRegex = nameRegex;
      vm.mobile = $rootScope.isMobileWebView;

      // profile settings page redirects to Livongo for BH2.0 users.
      vm.user.clientOfferingVersion = vm.user.clientOfferingVersion || 'MY1_0';
      vm.livongoSettingsUrl = window.MYSTRENGTH.config.livongoSettingsUrl;

      setEmailPrefsForUI();

      providerSvc.isFeatureEnabled(LAST_NAME).then(function (enabled) {
        vm.showLastName = enabled;
      });

      // determine if sleep diary is enabled
      vm.sleepDiaryEnabled = isSleepDiaryEnabled();

      var userHasCoachingAssignment = !_.isUndefined(vm.user.coachingAssignment) && vm.user.coachingAssignment !== null;

      if (userHasCoachingAssignment) {
        // Get coaching profile
        userSvc.getUsersCoachingProfile().then(function (resp) {
          var coachingElection = !_.isUndefined(resp.coachingElection) ? resp.coachingElection : null;
          vm.user.coachingEnabled = isCoachingEnabled(coachingElection);

          if (coachingElection === 'INELIGIBLE') {
            vm.userCanOptInOutOfCoaching = false;
          } else if (!_.isUndefined(vm.user.clientOfferingVersion) && vm.user.clientOfferingVersion === 'BH2_0') {
            vm.userCanOptInOutOfCoaching = false;
          } else {
            vm.userCanOptInOutOfCoaching = userHasCoachingAssignment;
          }

          createApiUser();
        });
      }

      createApiUser();
    }

    function createApiUser() {
      // Clone user to apiUser for determining if updates were made
      vm.apiUser = Object.assign(vm.apiUser, vm.user);
    }

    function setEmailPrefsForUI() {
      if (vm.user.userPreferences && vm.user.userPreferences[OPTED_INTO_COACHING_EMAIL_PREFERENCE_KEY]) {
        var optInCoachingEmailPreferenceValue = vm.user.userPreferences[OPTED_INTO_COACHING_EMAIL_PREFERENCE_KEY].toString();
        vm.user.optedIntoCoachingEmails = optInCoachingEmailPreferenceValue === 'true';
      }
      if (vm.user.userPreferences && vm.user.userPreferences[OPTED_INTO_ASSESSMENT_EMAIL_PREFERENCE_KEY]) {
        var optInAssessmentEmailPreferenceValue = vm.user.userPreferences[OPTED_INTO_ASSESSMENT_EMAIL_PREFERENCE_KEY].toString();
        vm.user.optedIntoAssessmentEmails = optInAssessmentEmailPreferenceValue === 'true';
      }
      if (vm.user.userPreferences && vm.user.userPreferences[OPTED_INTO_CONSUMER_EMAIL_PREFERENCE_KEY]) {
        var optInConsumerEmailPreferenceValue = vm.user.userPreferences[OPTED_INTO_CONSUMER_EMAIL_PREFERENCE_KEY].toString();
        vm.user.optedIntoConsumerEmails = optInConsumerEmailPreferenceValue === 'true';
      }
      if (vm.user.userPreferences && vm.user.userPreferences[OPTED_INTO_SLEEP_DIARY_EMAIL_PREFERENCE_KEY]) {
        var optInSleepDiaryPreferenceValue = vm.user.userPreferences[OPTED_INTO_SLEEP_DIARY_EMAIL_PREFERENCE_KEY].toString();
        vm.user.optedIntoSleepDiaryEmails = optInSleepDiaryPreferenceValue === 'true';
      }
    }

    function updatePreferences() {
      vm.user.userPreferences.emailPrefs = JSON.stringify(vm.emailPrefs);
      userSvc.savePreferences(vm.user.userPreferences).then(function () {
        // Update the UI's preferences model with most recent from server.
        setEmailPrefsForUI();
      });
    }

    function save() {
      var deferred = $q.defer();
      if (!vm.form.$valid) {
        angular.forEach(vm.form.$error.required, function (field) {
          return field.$setDirty();
        });
        // Focus first invalid input
        var invalidInputs = angular.element('input.ng-invalid');
        if (invalidInputs && invalidInputs[0]) {
          // Timeout for correct screen readers work
          $timeout(function () {
            return invalidInputs[0].focus();
          }, 500);
        }
        return $q.reject();
      } else if (_.isEqual(vm.user, vm.apiUser)) {
        $log.debug('User matches api, nothing to update');
        deferred.resolve();
      } else {
        userSvc.saveUser(vm.user, function () {
          createApiUser();

          updateSleepDiaryEmailSettings(vm.user.optedIntoSleepDiaryEmails).then(function () {
            languageSvc.setLanguage(vm.user.language);
            if (vm.userCanOptInOutOfCoaching) {
              setCoachingPreferences(vm.user.id, vm.user.coachingEnabled).then(function () {
                doWebViewPostMessage();
              }).catch(function () {
                doWebViewPostMessage();
              });
            } else {
              doWebViewPostMessage();
            }
          }).catch(function () {
            doWebViewPostMessage();
          });

          deferred.resolve();
        }, function (response) {
          handleUserSaveError(response, deferred);
        });
      }
      return deferred.promise;
    }

    function handleUserSaveError(response, deferred) {
      var data = response.data;
      if (data && data.hasOwnProperty('errorCode')) {
        var errorCode = data.errorCode;
        var message = data.message;

        if (_.includes(errorCode, 'USER_ALREADY_EXISTS')) {
          vm.emailBlacklist.push(vm.user.email);
          vm.form.email.$setValidity('blacklist', false);
          $('h2')[0].scrollIntoView(true);
        } else if (_.includes(message, 'password')) {
          vm.form.password.$setValidity('duplicate', false);
        } else {
          deferred.reject();
        }
        deferred.resolve();
      } else {
        // got no message back
        $state.go('error', {
          message: 'Unable to complete your request'
        });
      }
    }

    function isCoachingEnabled(coachingElection) {
      return coachingElection === 'ELIGIBLE' || coachingElection === 'OFFERED' || coachingElection === 'OPTED_IN';
    }

    function setCoachingPreferences(userId, coachingEnabled) {
      // Opt user in or out of coaching
      if (coachingEnabled) {
        return userSvc.coachingOptIn();
      } else {
        return userSvc.coachingOptOut();
      }
    }

    function isSleepDiaryEnabled() {
      return vm.user.userPreferences[SLEEP_DIARY_ENABLED_TRUE] && !vm.user.userPreferences[SLEEP_DIARY_DISABLED_TRUE];
    }

    function updateSleepDiaryEmailSettings(val) {
      //add metadata value if true, else remove
      if (val) {
        return userSvc.saveTagPreferences([OPTED_INTO_SLEEP_DIARY_EMAIL_PREFERENCE_KEY], []);
      } else {
        return userSvc.saveTagPreferences([], [OPTED_INTO_SLEEP_DIARY_EMAIL_PREFERENCE_KEY]);
      }
    }

    function doWebViewPostMessage() {
      if ($rootScope.isMobileWebView) {
        $rootScope.sendWebViewPostMessage('home');
      }
    }

    function getTranslationKey(language) {
      var languageCode = language.language.replace('-', '');
      return 'vnext.languages.' + languageCode;
    }
  }
})();